import { NumberType } from '../../../App/types';

export const replaceIndex = (pattern: string, idxVar: string, index?: NumberType) => {
  if (index === null || index === undefined) {
    return pattern;
  }
  return pattern.replace(idxVar, index.toString());
};
